import { getCssPackPath } from '@/libs/tinymce/utils/index'

// Настройки для поля slider на странице лендинга БГ
// /crm/bank_guarantee_pages/landing_id/edit/
export const bgSliderSettings = {
  body_class: 'infoItemContent',
  content_css: getCssPackPath(),
  height: 300,
  plugins: 'code,link,lists,table',
  style_formats: [
    { title: 'p', block: 'p', classes: false },
    { title: 'div', block: 'div', classes: false },
    { title: 'Подзаголовок 1', block: 'h2'},
    {
      items: [
        { title: 'Заголовок', block: 'div', classes: 'incut__caption' },
        { title: 'Текст', block: 'div', classes: 'incut', wrapper: true},
      ],
      title: 'Врезка',
    },
    {
      items: [
        { title: 'Цитата', block: 'blockquote', wrapper: true },
        { title: 'Автор', block: 'div', classes: 'quote__author' },
        { title: 'Должность', block: 'div', classes: 'quote__about' },
        { title: 'Текст', block: 'div', classes: 'quote__text' },
      ],
      title: 'Цитата',
    },
  ],
  toolbar: [
    `styleselect | fontsizeselect bold italic underline | bullist numlist outdent indent blockquote | undo redo
    | link | alignleft aligncenter alignright alignjustify | code | table`,
  ],
}
